import { render, staticRenderFns } from "./excelparserbrands.vue?vue&type=template&id=d33f1730&"
import script from "./excelparserbrands.vue?vue&type=script&lang=js&"
export * from "./excelparserbrands.vue?vue&type=script&lang=js&"
import style0 from "./excelparserbrands.vue?vue&type=style&index=0&id=d33f1730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports